function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "a",
  cx: 63.489,
  cy: 64.754,
  r: 59.119,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#09009b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#08008e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.607,
  stopColor: "#04006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000046"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M58.98 42.98c3.16 3.44 10.78 1.7 14.75-3.4 3.97-5.11 11.35-15.32 6.53-26.67C75.43 1.55 58.16 1.93 49.9 4.39c-16.04 4.76-32.92 19-38.64 40.35-5.32 19.86-7.05 42.5 4.59 57.54s38.02 15.61 50.22 7.09S91.32 77.88 95.3 73.9c3.97-3.97 8.51-10.21 14.75-7.09 6.24 3.12-.28 12.48-3.4 15.61-3.12 3.12-12.48 12.77-9.36 24.12s20.2 19.99 20.2 19.99-17.48-16-12.94-27.63 12.03-14.78 14.3-21.02c2.27-6.24.65-14.06-5.31-15.89-7.9-2.43-12.85 0-21.93 7.66s-20.43 24.97-34.9 29.51-31.99 1.82-35.72-12.28c-3.7-13.99-2.72-29.84 4.38-46.3S40.62 15.12 53.35 10.7c12.56-4.36 17.26-.08 19.53 2.19 2.27 2.27 5.08 11.52-2.18 14.33-8.07 3.12-17.77 9.17-11.72 15.76z",
  fill: "url(#a)"
});

var _ref4 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "b",
  cx: 164.748,
  cy: 52.86,
  r: 64.519,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#09009b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#08008e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.607,
  stopColor: "#04006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000046"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M91.04 3.53c3.88-2.97 7.94 1.13 10.21 5.96 2.27 4.82 4.26 8.23 8.51 7.09s15.04-12.48 21-12.48c5.96 0 6.81 3.4 6.53 6.81-.28 3.4-3.12 9.08.85 9.65 3.97.57 12.23-5.17 17.88-9.08 6.78-4.7 9.47-6.68 15.04-6.24 7.66.6 5.96 10.21 3.4 13.9s-19.85 24.26-27.7 35.49c-11.3 16.17-14.87 28.06-10.61 37.43s26.39-3.97 32.06-7.38 14.67-11.89 20.71-11.35c3.11.28 5.64 1.46 9.36 6.24 4.07 5.23 11.97 3.81 16.74-.57 4.23-3.89 12.77-14.47 25.82-14.47 0 0-16.79 4.18-22.7 17.31-3.54 7.87-14.19 8.8-18.73 5.96-4.54-2.84-4.82-10.78-13.34-8.23s-13.05 12.77-33.2 21-27.65-5.21-28.41-9.86c-1.08-6.63-1.39-16.24 8.26-31s28.14-37.68 32.82-43.81c0 0-21.47 12.32-30.26 11.75-8.8-.57-1.7-11.35-5.67-12.77-3.97-1.42-7.38 1.99-13.9 6.53-6.53 4.54-16.17 3.12-21.28-1.7S86.22 7.22 91.04 3.53z",
  fill: "url(#b)"
});

var _ref6 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "c",
  cx: 216.006,
  cy: 62.327,
  r: 62.251,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#09009b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#08008e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.607,
  stopColor: "#04006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000046"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M185.53 12.33c.94-2.93 5.55-4 14.59-.62 9.15 3.41 14.87 6.33 23.68 15.14 7.88 7.88 13.76 15.84 24.44 16.41 8.5.46 15.57-8.03 18.41-16.25 2.84-8.23 6.15-24.08 13.94-21.77 6.24 1.86-2.27 13.05-4.54 16.46-2.27 3.4-12.14 16.18-10.44 25.26s8.73 18.01 5.46 28.2c-3.7 11.54-12.89 15.21-22.25 16.06-9.36.85-10.5-1.7-18.16 3.97s-7.38 19.58-18.16 23.27-15.04-9.65-26.1-8.23c-11.07 1.42-11.92 10.21-23.27 9.36-11.35-.85-15.61-10.78-13.34-13.05 2.27-2.27 6.24 1.42 11.63 4.54 5.39 3.12 11.92 0 19.29-3.97s13.34-1.42 21.56 2.27c8.23 3.69 13.9-2.27 17.02-9.08 3.12-6.81 7.66-13.62 17.31-15.61 9.65-1.99 24.13.2 26.93-8.16 2.33-6.94-2.31-11.02-4.01-18.68s-1.36-10.9-1.36-10.9-11.16 7.93-22.98.57c-8.73-5.43-9.28-17-22.33-22.39-13.05-5.39-30.02-4.35-27.32-12.8z",
  fill: "url(#c)"
});

var _ref8 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "d",
  cx: 294.604,
  cy: 65.131,
  r: 59.596,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#09009b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#08008e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.607,
  stopColor: "#04006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000046"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M295.19 36.96c-.01-11.23 8.72-27.79 27.88-30.02 19.05-2.21 29.82 6.43 31.85 19.29 2.14 13.6-6.81 28.66-19.01 28.66-12.2 0-19.58-8.8-18.16-19.29s10.64-13.79 15.84-13.4c3.31.25 7.3 2.24 8.32 6.09.4 1.52.7 3.02-.29 5.42-2.96 7.15-9.65 4.31-11.11 3.59-.58-.28-3.07-2.15-2.8-2.68.08-.17 1.16 1.16 4.26 1.16 3.44 0 6.71-1.72 6.36-4.7-.35-2.98-4.61-5.55-8.51-4.95-2.58.4-9.03 3.33-6.6 12.86 1.71 6.7 8.94 9.47 14.9 7.54 5.96-1.93 12.31-10.05 10.69-18.06-1.59-7.87-4.73-15.95-15.78-16.48-11.05-.53-19.45 3.95-23.54 12.19-4.7 9.48-5.94 26.54 4.25 34.62 8.36 6.63 21.81 16.31 21.28 30.69-.53 14.38-10.76 31.2-29 33.66-18.23 2.45-28.38-4.19-34.69-8.4-6.31-4.21-10.4-10.39-21.97-9.16-11.57 1.23-15.01 1.36-15.4-.58-.61-3.05 9.94-5.04 16.66-5.17 6.74-.13 14.57 3.09 23.94 10.77 6.23 5.1 19.19 9.74 28.49 6.23 9.29-3.51 17-12.48 19.1-21.42 2.1-8.94 1.51-17.36-6.2-22.8-7.69-5.45-20.74-13.35-20.76-35.66z",
  fill: "url(#d)"
});

var _ref10 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "e",
  cx: 410.727,
  cy: 68.276,
  r: 66.767,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#09009b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#08008e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.607,
  stopColor: "#04006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000046"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M484.24 11.85c-9.03-2.63-32.13-5.94-43.5 3.04-9.46 7.46-18.5 4.79-24.1 3.76-5.55-1.03-11.19-2.47-20.96-5.29s-17.48 2.11-20.45 8.57c-1.95 4.25-3.8 9.48-11.7 26.21-7.9 16.74-26.31 12.87-26.31 12.87s17.09 6.49 26.5-3.47 11.68-18.03 13.54-23.13c2.53-6.96 6.02-15.42 12.97-15.79 6.96-.38 10.72 1.32 18.43 6.21s13.54 12.41 12.03 21.62-14.79 16.23-25.5 19.73c-9.25 3.02-29.31 12.64-28.37 24.11.94 11.47 19.8 20.04 26.39 23.63 1.74.94 3.62 2.2 4.4 7.44.87 5.88 3.23 6.69 5.03 5.95 1.81-.74 3.3-2.96 2.11-7.53-1.26-4.85-2.62-8.05-9.02-10.86-7.03-3.09-25.06-10-24.31-18.09s16.01-13.38 22.02-15.07c6.02-1.69 23.86-7.3 29.31-15.2 5.45-7.9 5.45-14.1 2.44-20.68s-4.28-10.71-2.59-12.03 5.83 1.23 14.1-2.15 8.97-6.47 16.07-9.92c10.92-5.32 31.47-3.93 31.47-3.93z",
  fill: "url(#e)"
});

var _ref12 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "f",
  cx: 492.783,
  cy: 65.15,
  r: 56.979,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#09009b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#08008e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.607,
  stopColor: "#04006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000046"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M515.64 44.76c1.88-14.85.35-20.79-5.46-24.08-5.11-2.9-20.49 5.52-28.04 8.68-7.82 3.28-17.56 7.24-26.64 12.19-8.31 4.53-17.32 11.1-17.13 21.63.19 10.53 7.9 14.85 16.36 12.6 8.46-2.26 11.47-8.46 12.6-12.6s-2.44-9.78-8.27-9.21c-5.83.56-6.77 6.96-5.08 10.34 1.69 3.38 5.38 1.43 6.38-.15 1.82-2.86.69-6.44.69-6.44s3.08 1.89 2.33 6.78-6.96 8.46-11.47 4.89-3.68-11.22-.94-14.89c4.09-5.47 13.35-4.29 16.17-1.84 2.82 2.44 6.48 8.69.38 20.5-4.79 9.26-16.26 10.28-21.81 9.4-4.99-.79-12.79-6.58-13.54-19.37s13.97-25.98 23.87-30.05c24.32-10 38.09-18.41 44.03-20.14 5.31-1.55 16.36-2.26 22.19 7.9s1.33 26.46-1.02 32.61c-1.98 5.19-8.98 19.44-11.42 30.91s3.21 24.07 9.23 25.77c6.02 1.69 8.84-2.82 10.15-6.77 1.32-3.95 1.32-10.34 5.83-20.12 4.51-9.78 18.08-30.67 18.43-30.46.16.1-11.5 18.6-12.26 32.14s-2.03 22.39-6.55 27.28c-4.51 4.89-11.66 8.65-20.87 3.38-9.21-5.26-13.54-17.86-12.22-30.27 1.32-12.41 6.58-20.31 9.21-26.14 2.62-5.82 4.87-14.47 4.87-14.47z",
  fill: "url(#f)"
});

var _ref14 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "g",
  cx: 468.761,
  cy: 71.849,
  r: 48.74,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#09009b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#08008e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.607,
  stopColor: "#04006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000046"
}));

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M504.19 89.45s-10.3 6.68-22.39 14.91c-10.73 7.3-26.24 14.92-35.54 13.54-11.23-1.67-13.96-15.15.05-20.18 11.34-4.07 33.84-16.06 42.38-24.45 9.12-8.96 17.67-23.4 20.49-31.86 2.04-6.13 3.57-15 3.71-18.5.05-1.33-1.81-4.02-1.81-4.02s-.9 10.44-3.39 17.6c-3.72 10.67-13.15 31.37-41.3 44.94-10.69 5.15-29.33 9.03-37.04 16.74s-4.31 17.82-1.13 21.25c4.58 4.94 12.23 6.27 23.69 4.89 13.96-1.68 33.85-16.36 40.62-21.25 5.08-3.67 10.22-8.08 11.92-10.38.55-.78-.26-3.23-.26-3.23z",
  fill: "url(#g)"
});

var _ref16 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "h",
  cx: 602.029,
  cy: 64.222,
  r: 57.184,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#09009b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#08008e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.607,
  stopColor: "#04006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000046"
}));

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M545.01 6.88s.73 14.63 14.31 22.58 22.3 6.92 26.66 22.05-3.75 22.09-12.47 29.52-10.05 13.73-12.37 18.56c-2.64 5.49-10.8 12.17-12.59 14.99-1.79 2.82-2.82 5.38-.77 6.67 2.05 1.28 9.49-1.28 19.48-6.92 10-5.64 25.38-2.82 31.28-.51 5.9 2.31 11.02 6.15 20.25 4.61s18.97-6.15 21.28-17.18c2.31-11.02 2.31-23.07 5.13-30 2.82-6.92 12.38-23.26 13.84-25.89 0 0-16.92 17.69-22.3 29.23-5.38 11.54-5.38 20.51-7.43 26.15-2.05 5.64-8.72 12.31-19.23 11.79-10.51-.51-11.54-11.79-22.05-13.84-10.51-2.05-18.2 2.56-23.33 6.92 0 0 3.57-9.04 7.16-14.68 3.59-5.64 13.41-10.4 20.79-18.65 8.92-9.98 7.18-27.69-3.08-35.64-10.26-7.95-17.69-6.67-27.94-12.56s-16.62-17.2-16.62-17.2z",
  fill: "url(#h)"
});

var _ref18 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "i",
  cx: 179.705,
  cy: 198.631,
  r: 133.096,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#09009b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#08008e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.607,
  stopColor: "#04006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000046"
}));

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M51.93 174.78s-20.1 4.35-18.99 14.03c1.11 9.68 16.04 6.64 16.04 6.64s15.21-5.26 14.38-16.87c-.83-11.62-13.28-17.7-23.79-16.32-10.51 1.38-27.09 17.45-27.94 27.39-1.37 15.99 11.68 40.85 29.94 50.25 18.26 9.41 38.91 7.92 54.68 5.7s46.29-20.8 65.07-42.94c10.59-12.48 23.86-45.36 29.84-52.86 7.07-8.86 15.21-15.77 17.7-15.77 2.49 0 3.87 13.83 12.17 17.98s18.08 4.3 23.51 8.85c7.16 6 4.15 22.13-1.11 28.22s-15.77 17.15-26.83 25.45-28.22 22.96-31.26 32.64c0 0 23.82-7.04 35-8.96 11.74-2.01 20.8-1.49 31.87-5.37 11.06-3.87 21.73-13.08 27.07-29.75 2.28-7.13 4.18-31.85 9.99-41.53 5.81-9.68 30.51-28.08 30.51-28.08s4.32 13.87 4.47 29.64c.22 23.18-16.08 50.58-24.11 60.82-8.02 10.24-12.45 24.07-2.49 28.77 9.96 4.7 23.88.51 34.39-7.78s19.27-24.03 16.78-31.77c-2.49-7.75-5.65-9.79-10.35-9.04-4.64.74-8.48 6.16-9.51 11.03-.76 3.59-.61 9.35 4.92 9.63s4.5-4.58 2.36-7.93c-1.8-2.82-1.24-5.75.57-6.52 3.31-1.42 8.27 4.13 6.33 10.49-1.94 6.36-5.87 10.02-12.14 8.78-8.76-1.73-8.64-15.12-5.07-21.57 3.8-6.88 12.38-12.3 20.95-8.43s10.51 17.43 8.85 24.34-7.75 17.98-22.41 29.6c-14.66 11.62-30.71 9.41-36.79 7.47-6.09-1.94-16.87-10.79-9.68-25.45 7.19-14.66 17.94-35.09 21.18-42.56 11.98-27.59 7.23-45.01 7.23-45.01s-15.66 7.21-20.69 25.76c-2.43 8.95-1.51 19.26-5.93 30.6-4.43 11.34-18.63 27.67-25.85 31.49-9.58 5.06-57.17 14.89-68.05 17.7-9.44 2.44-30.98 10.24-30.98 10.24s3.87-7.75 13.28-17.43 21.7-25.38 33.26-36.77c7.67-7.56 25.33-19.92 27.82-29.05 2.49-9.13-4.12-12.9-14.05-15.5-17.21-4.52-21.3-17.15-21.3-17.15s-4.67 3.79-10.08 13.53c-4.26 7.68-8.38 19.5-15.09 32.94-6.74 13.5-46.92 57.86-92.5 63.76-33.56 4.35-57.84-11.09-69.34-25.74-8.62-10.99-14.69-32.84-12.04-45.26 2.96-13.87 14.26-21.26 28.92-27.07s31.42 1.45 35.37 8.07c4.01 6.72 5.02 15.16-3 26.78-8.02 11.62-25.45 11.34-33.19 7.19-7.75-4.15-5.77-15.73-.28-21.58 8.53-9.04 20.39-5.72 20.39-5.72z",
  fill: "url(#i)"
});

var _ref20 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "j",
  cx: 412.555,
  cy: 195.152,
  r: 65.215,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#09009b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#08008e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.607,
  stopColor: "#04006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000046"
}));

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M368.94 171.39c9.33 1.28 22.99-1.57 34.19-11.42s14.84-17.86 22.46-17.86 20.28 6.46 20.84 23.02c1.05 31.54-33.09 58.26-28.21 78.82 3.8 16.02 30.96 17.81 44.65 5.7 11.15-9.87 23.13-31.49 14.92-33.47-3.38-.81-7.47-.36-9.71 8.15-2.24 8.51 1.21 10.54-9.1 21.41-9.63 10.15-31.23 10.73-33.14-2.24-3.58-24.32 34.02-49.05 29.16-79.95-3.04-19.32-15.97-28.74-28.96-28.29-12.99.45-20.26 12.18-29.17 19.55-10.3 8.51-19.29 13.01-30.29 9.85-14.37-4.13-8.51-11.19-11.52-22.48-1.65-6.2-4.9-10.07-7.6-9.29-2.66.77-3.9 10.25-1.66 17.87 2.22 7.6 9.5 18.75 23.14 20.63z",
  fill: "url(#j)"
});

var _ref22 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "k",
  cx: 409.44,
  cy: 195.511,
  r: 46.305,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#09009b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#08008e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.607,
  stopColor: "#04006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000046"
}));

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M435.67 142.28s.45 12.99-5.37 20.6c-5.82 7.61-21.32 15.86-31.91 21.93-17.72 10.16-28.59 27.1-26.92 42.7 1.25 11.67 15.59 38.06 36.89 5.68 13.18-20.03 36.38-49.11 36.38-49.11l2.84-7.45s-18.63 22.51-27.14 31.92-22.09 34.21-30.6 32.87c-8.51-1.34-10.34-16.14-3.53-31.19 8.84-19.52 29.3-26.18 37.5-32.67 12.72-10.07 14.34-19.75 13.44-33.63l-1.58-1.65z",
  fill: "url(#k)"
});

var _ref24 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "l",
  cx: 483.015,
  cy: 200.99,
  r: 63.012,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#09009b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#08008e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.607,
  stopColor: "#04006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000046"
}));

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M430.2 269.51s25 2.82 35.43-5 15.64-10.1 24.12-12.38 24.77-9.45 29.01-16.62c4.24-7.17 10.91-16.8 5.37-33.1s-13.84-20.35-21.99-28.5c-8.15-8.15-13.9-20.84-5.26-44.69 0 0-.48 15.79 4.02 26.02 3.69 8.41 7.89 15.37 15.25 19.97 9.31 5.82 15.82 13.39 18.9 28.35 2.93 14.22-2.93 28.03-8.8 35.2-5.87 7.17-15.97 14.99-32.27 18.25-16.3 3.26-22.45 8.53-29.33 13.04-9.79 6.41-34.45-.54-34.45-.54z",
  fill: "url(#l)"
});

var _ref26 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "m",
  cx: 537.541,
  cy: 170.51,
  r: 33.839,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#09009b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#08008e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.607,
  stopColor: "#04006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000046"
}));

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M505.07 165.43s1.3-15.97 10.76-22.81c9.45-6.84 21.81-8.7 31.29-6.19 13.73 3.64 23.97 16.67 22.81 38.78-.94 17.91-7.5 27.38-18.58 29.98-11.08 2.61-23.14-6.52-23.14-6.52l-.59-5.54s14.6 10.75 23.73 4.56 11.44-23.29 9.45-32.27c-1.94-8.75-5.87-18.25-18.58-19.23-12.71-.98-19.3.95-26.07 6.52-10.26 8.45-6.92 19.31-6.92 19.31l-4.16-6.59z",
  fill: "url(#m)"
});

function SvgCrystalMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 661.39 276.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystalMap);
export default __webpack_public_path__ + "static/media/crystal-map.a39b1875.svg";
export { ForwardRef as ReactComponent };